module.exports = __webpack_public_path__ + "img/surface_go_lte_advanced_silver.6587bbde.png";